<template>
    <img :src="`img/logo/main/${isWebExpensesApp ? 'webexpenses' : 'zudello'}.png`" :alt="appDisplayName">
</template>

<script>
export default {
    name: 'AppAuthLogo'
}
</script>
